// Memoria Operativa lato visitatore: conta i dettagli che l'AI ha imparato dai suoi testi.
import { useEffect, useState } from "react";
import api from "@/lib/api";
import { leggiTipo } from "@/lib/segmento";

const EVENTO = "op-memoria";
const REGOLE = [
  { chiave: "sfrido", test: /\+?\s?\d+\s?%\s?(?:di\s)?sfrido/i },
  { chiave: "percentuale", test: /\d+\s?%/ },
  { chiave: "acconto", test: /acconto/i },
  { chiave: "tariffa", test: /\d+\s?(?:€|eur)\s?\/?\s?(?:mq|m2|h|ora|giorno|giornata)?/i },
  { chiave: "spese", test: /spes[ae]/i },
  { chiave: "forfettario", test: /forfettar/i },
  { chiave: "iva", test: /\biva\b|esente|art\.?\s?10/i },
  { chiave: "materiali", test: /material|fornitur|posa/i },
  { chiave: "cliente", test: /client|studio|azienda|sig\.?/i },
  { chiave: "tempi", test: /\d+\s?(?:giorn|settiman|mes)/i },
];

export const leggiMemoria = () => {
  if (typeof window === "undefined") return { count: 0, dettagli: [] };
  try {
    const dettagli = JSON.parse(localStorage.getItem("memoria_dettagli") || "[]");
    return { count: Number(localStorage.getItem("memoria_count") || 0), dettagli };
  } catch {
    return { count: 0, dettagli: [] };
  }
};

/** Registra cosa la memoria ha imparato da un testo della demo. */
export const imparaDa = (brief, { correzione = false } = {}) => {
  const { dettagli } = leggiMemoria();
  const nuovi = new Set(dettagli);
  REGOLE.forEach(({ chiave, test }) => {
    if (test.test(brief)) nuovi.add(chiave);
  });
  if (correzione) nuovi.add(`correzione-${nuovi.size}`);
  const elenco = [...nuovi];
  localStorage.setItem("memoria_dettagli", JSON.stringify(elenco));
  localStorage.setItem("memoria_count", String(elenco.length));
  window.dispatchEvent(new CustomEvent(EVENTO, { detail: elenco.length }));

  let visitor = localStorage.getItem("op_visitor");
  if (!visitor) {
    visitor = `v${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`;
    localStorage.setItem("op_visitor", visitor);
  }
  api
    .post("/public/memoria-stats", {
      visitor_id: visitor,
      email: localStorage.getItem("op_email") || "",
      tipo: leggiTipo(),
      count: elenco.length,
      details: elenco,
    })
    .catch(() => {});
  return elenco.length;
};

export const useMemoria = () => {
  const [count, setCount] = useState(() => leggiMemoria().count);
  useEffect(() => {
    const ascolta = (e) => setCount(e.detail);
    window.addEventListener(EVENTO, ascolta);
    return () => window.removeEventListener(EVENTO, ascolta);
  }, []);
  return count;
};
